<template>
  <div id="mapPage" class="page">
    <MapHeader appTitle="Water Map Project" />
    <div class="container">
      <OlMap
        class="map"
        :sources="sources"
        @selectSource="setSelectedSource($event)"
      />
      <SideBar class="panel" :source="selectedSource" :date="selectedDate" />
    </div>
    <div class="bottomPanel">
      <FilterPanel
        :sources="sources"
        @setSelectedDate="setSelectedDate($event)"
      />
    </div>
  </div>
</template>

<script>
import MapHeader from "../components/MapHeader.vue";
import OlMap from "../components/OlMap.vue";
import SideBar from "../components/SideBar.vue";
import FilterPanel from "../components/FilterPanel.vue";
import api from "../data/Api";

export default {
  name: "MapPage",
  components: {
    MapHeader,
    OlMap,
    SideBar,
    FilterPanel,
  },
  methods: {
    getData: function() {
      console.log("trying to get sources");
      api.getAllSources().then(
        (result) => {
          console.log("saving sources");
          this.sources = result.data;
        },
        (error) => {
          console.error(error);
        }
      );
    },
    setSelectedDate(date) {
      this.selectedDate = date;
      this.recomputeSelectedSource();
    },
    setSelectedSource(source) {
      this.selectedSource = source;
    },
    recomputeSelectedSource() {
      // pick source closest to date
      // console.log("setting source because date changed: ")
      // this.selectedSource = this.sources[0]
      // console.log("All sources: ")
      // console.log(this.sources)
      // console.log("Selected source: ")
      // console.log(this.selectedSource)
    },
  },
  props: {
    date: Date,
  },
  data() {
    return {
      sources: [],
      selectedSource: null,
      selectedDate: null,
    };
  },
  mounted() {
    this.getData();
  },
};
</script>

<style>
.container {
  display: flex; /* establish flex container */
  flex-direction: row; /* default value; can be omitted */
  flex-wrap: nowrap; /* default value; can be omitted */
  justify-content: space-between; /* switched from default (flex-start, see below) */
  height: 85%;
  /* display: inline-block; */
  /* background-color: lightyellow; */
}

.bottomPanel {
  height: 15%;
  display: inline-block;
}

.page {
  display: flex; /* establish flex container */
  flex-direction: column; /* default value; can be omitted */
  flex-wrap: nowrap; /* default value; can be omitted */
  justify-content: space-between; /* switched from default (flex-start, see below) */
  /* background-color: lightyellow; */
}
.map {
  width: 80%;
  /* height: 85%; */
  display: inline-block;
}
.panel {
  display: inline-block;
  width: 20%;
}
</style>
